import { ChangeDetectionStrategy, Component, computed } from '@angular/core';

import { ReadonlyDisplayBase } from './readonly-display.base';
import { formatDisplayValue } from '../../review-value.util';
import { displayContextFor } from '../display-context.util';

/**
 * Default read display (#21239): the field's answer as one line of text.
 *
 * This is what every field type gets until a richer display is registered for it — chips for a
 * multi-select, a thumbnail for an image, a link for a linked entry. The text rule is the SHARED
 * `formatDisplayValue`, so the detail page in read mode, the wizard's review step and the
 * onboarding-review card cannot drift on Ja/Nee, dates, option labels or composite shapes.
 *
 * Presentational: both inputs come from the row, and the option-label context is read off the
 * field (`displayContextFor`) rather than from an injected store — a story renders it with no
 * DI beyond Formly.
 *
 * No styling of its own: it renders inside `dd-label-list`'s value span and inherits that span's
 * type, color, truncate and sentry-mask. A display that needs its own box (a badge, a chip row)
 * brings its own classes.
 */
@Component({
  selector: 'dd-value-display',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // display: contents — the display must not become a box inside the value span, or the row's
  // truncate/multiline behaviour would stop at this element.
  styles: `
    :host {
      display: contents;
    }
  `,
  template: `{{ text() }}`,
})
export class ValueDisplayComponent extends ReadonlyDisplayBase {
  /** Em dash for "no answer": an empty row still has to read as a row, not as a rendering gap. */
  readonly text = computed(() => formatDisplayValue(this.value(), displayContextFor(this.field())) ?? '—');
}
